import { select, put, takeEvery, delay, takeLatest } from 'redux-saga/effects';
import { v4 as uuid } from 'uuid';
import { UserMessage, ConversationAPI, Comment } from 'api/conversations';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { createCommentAction } from '../actions';
import { selectConversation } from '../selectors';
import { createComment, updateComment } from '../slices';
import { CommentActionPayload } from '../types';

function* createCommentOnApiSaga({
  payload,
}: StoreActionProps<CommentActionPayload<UserMessage>>) {
  const { comment: newComment, context } = payload;
  const commentGuid = uuid();

  const comment = { ...newComment, commentGuid };

  yield put(
    createComment({
      comment: { ...comment, createdAt: +new Date() },
      context,
    }),
  );

  const commentFromStore = yield select(selectConversation(context));

  try {
    const updatedComment = yield ConversationAPI.createComment(
      commentFromStore.projectId,
      commentFromStore.context,
      comment,
    );

    yield put(
      updateComment({
        comment: updatedComment,
        context,
      }),
    );
  } catch (error) {
    logger.error('updateComment failed', { error });
  }
}

export const watchCreateCommentOnapiSaga = function* (): Generator {
  yield takeEvery(createCommentAction.type, createCommentOnApiSaga);
};

function* createCommentOnWS(
  action: StoreActionProps<CommentActionPayload<Comment>>,
) {
  const { comment, context } = action.payload;

  try {
    // TODO:: Remove this delay and unify both ws and api actions and avoid race condition
    // https://redux-saga.js.org/docs/advanced/RacingEffects.html
    yield delay(500);
    yield put(
      createComment({
        comment,
        context,
      }),
    );
  } catch (error) {
    logger.error('createComment failed', { error });
  }
}

export const watchCreateCommentOnWSSaga = function* (): Generator {
  yield takeLatest('@@conversations/createCommentActionWS', createCommentOnWS);
};
